import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { OtherService } from 'src/app/services/other.service';

import { AccountService } from 'src/app/services/account.service';

import { fromEvent, interval, take, takeUntil, takeWhile } from 'rxjs';

import { MapService } from 'src/app/services/map.service';

import { Meta, Title } from '@angular/platform-browser';

@Component({

  selector: 'app-login',

  templateUrl: './login.component.html',

  styleUrls: ['./login.component.css'],


})

export class LoginComponent implements OnInit {

  lst_States: any = [];

  list_City: any = [];

  lst_FloatingType: any = [];

  bSendOtp: boolean = false;

  bLoginMode: boolean = true;

  isFromLoginForm: boolean = false;

  isFromAnotherComponent: boolean = true;

  rulesRead: boolean = false;

  openMap: boolean = false;

  otpTimer: any | number = 0;

  redirectTo: string;

  redirectTo_id: number | string | null = null;

  valid_MaxLength: number = (<any>window).maxLength_Mobile;

  forceAddress: number = (<any>window).forceAddress;

  valid_PlaceHolder: number = (<any>window).input_Placeholder;

  addressPlaceHolder: string = '';

  signUpModel: FormGroup = this.formBuilder.group({

    strName: new FormControl('', Validators.required),

    strFamily: new FormControl('', Validators.required),

    strID: new FormControl('', Validators.required),

    strStateCode: new FormControl('', Validators.required),

    strCity: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    tiFloatingType: new FormControl('-1', Validators.required),

    iPower: new FormControl('', Validators.required),

    strVIN: new FormControl(''),

    strAddress: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

    strComment: new FormControl(''),

    strOtp: new FormControl(''),

    strLicenseNo: new FormControl('', Validators.required),

    strActivateCode: new FormControl(''),

    rules: new FormControl(false),

    bHas12DC: new FormControl(false),

    tiFloats: new FormControl(''),

  });

  mdl_Map: FormGroup = this.formBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  });

  constructor(

    public route: ActivatedRoute,

    private router: Router,

    private formBuilder: FormBuilder,

    private accountService: AccountService,

    private otherService: OtherService,

    private _MapService: MapService,

    private meta: Meta,

    private title: Title


  ) {

    this.addressPlaceHolder = this.forceAddress ? '* آدرس محل نصب (الزامی)' : 'آدرس محل نصب (اختیاری)';

  }

  ngOnInit(): void {

    this.title.setTitle('ورود به حساب کاربری | ShilatGPS – ردیاب شیلات، قایق و کشتی');

    if (this.forceAddress) {

      const address = this.signUpModel.get('strAddress');
      address?.addValidators(Validators.required);
      address?.updateValueAndValidity();

      const fLat = this.signUpModel.get('fLat');
      fLat?.addValidators(Validators.required);
      fLat?.updateValueAndValidity();

      const fLon = this.signUpModel.get('fLon');
      fLon?.addValidators(Validators.required);
      fLon?.updateValueAndValidity();

    }

    this.meta.addTags([

      { name: 'description', content: 'در صفحه ورود به حساب کاربری ShilatGPS، کاربران می‌توانند با وارد کردن اطلاعات خود وارد سیستم شده و از خدمات ردیاب شیلات، قایق، لنج و کشتی بهره‌برداری کنند.' },

      { name: 'keywords', content: 'ورود به حساب کاربری, ShilatGPS, ردیاب شیلات, ردیاب قایق, ردیاب لنج, ردیاب کشتی, ورود به سیستم' }

    ]);

    // login by dolateMan
    this.route.queryParamMap.pipe(take(1)).subscribe(params => {

      if (!params.keys.length) return;

      const allParams: Record<string, string | null> = {};

      params.keys.forEach(key => {

        allParams[key] = params.get(key);

      });

      this.accountService.loginByDolateMan(allParams).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if (res?.ISSessionExpired === true) {
          this.otherService.logout();
          this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
          this.accountService.toastSwal(
            'error',
            'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
          );
        }

        if (res.iResult === 0) {

          this.accountService.toastSwal('error', res.strError);

          return;

        }

        this.initializeSignUpModel(res);

      });

    });

    // صفحه ریدایرکت 

    this.route.paramMap.subscribe((params) => {

      this.redirectTo = params.get('redirectTo');

    });


  }

  initializeSignUpModel(response) {

    this.initialize();

    this.isFromLoginForm = false;

    this.bLoginMode = false;

    this.bSendOtp = false;

    this.markAllAsUnTouched(this.signUpModel);

    Object.keys(response).forEach((key) => {

      this.signUpModel.get(key)?.setValue(response[key]);

      this.signUpModel.get(key)?.updateValueAndValidity();

    });

    if (this.signUpModel.value.strStateCode != '') {

      this.getCity(this.signUpModel.value.strStateCode, false);

    }

  }

  get isSignUpMode() {

    return !this.bLoginMode && !this.bSendOtp;

  }

  get isLoginMode() {

    return this.bLoginMode && !this.bSendOtp;

  }

  get isOtpMode() {

    return this.bSendOtp && !this.bLoginMode;

  }

  get otpMessage() {

    const mobile = this.signUpModel.get('strMobile')?.value;

    return `کد به شماره ${mobile} پیامک شد.`;

  }

  initialize() {

    if (!this.lst_States.length) {

      this.accountService.GetState().subscribe((response) => {

        let res = JSON.parse(response.toString());

        this.lst_States = res;

      });

    }

    if (!this.lst_FloatingType.length) {

      this.accountService.floatingType().subscribe((response) => {

        let res = JSON.parse(response.toString());

        this.lst_FloatingType = res;

      });

    }

  }

  changeNumber() {

    this.bSendOtp = false;

    this.bLoginMode = true;

    this.isFromLoginForm = false;

    this.signUpModel.get('strMobile')?.enable();

    this.signUpModel.patchValue({

      strMobile: ''

    });

    this.markAllAsUnTouched(this.signUpModel);

  }

  onSubmit() {

    if (this.bLoginMode) {

      this.login_User();

      return;

    }

    if (!this.bSendOtp && !this.bLoginMode) {

      this.signUp_User();

      return;

    }

    if (this.bSendOtp && !this.bLoginMode) {

      this.check_Otp();

      return;

    }

  }

  login_User() {
    const mobileCtrl = this.signUpModel.get('strMobile');
    mobileCtrl?.markAsTouched();
    mobileCtrl?.markAsDirty();
    mobileCtrl?.updateValueAndValidity();

    var model = {
      strMobile: (mobileCtrl?.value ?? '').trim(),
    };

    if (!model.strMobile || model.strMobile.length !== this.valid_MaxLength) {
      if (mobileCtrl?.hasError('pattern')) {
        const e = { ...mobileCtrl.errors };
        delete (e as any)['pattern'];
        mobileCtrl.setErrors(Object.keys(e).length ? e : null);
      }
      return;
    }

    const mobileRegex = /^09\d{9}$/;

    if (!mobileRegex.test(model.strMobile)) {
      mobileCtrl?.setErrors({ pattern: true });
      mobileCtrl?.markAsTouched();
      return;
    } else {
      if (mobileCtrl?.hasError('pattern')) {
        const errors = { ...mobileCtrl.errors };
        delete (errors as any)['pattern'];
        mobileCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    this.accountService.checkMobile(model).subscribe((data) => {

        let res = JSON.parse(data.toString());

        // اگر حساب کاربری داشت 

        if (res[0]?.iPreregistration) {

          this.bLoginMode = false;

          this.bSendOtp = true;

          this.isFromLoginForm = true;

          this.signUpModel.get('strMobile').disable();

          setTimeout(() => {

            this.startOtp_Timer();

          }, 10);

          return;

        }

        //  اگر ثبت نام نکرده بود

        else {

          this.initialize();

          this.isFromLoginForm = false;

          this.bLoginMode = false;

          this.bSendOtp = false;

          this.markAllAsUnTouched(this.signUpModel);

          this.signUpModel.patchValue({

            strName: '',

            strFamily: '',

            strID: '',

            strStateCode: '',

            strCity: '',

            strAddress: '',

            tiFloatingType: '-1',

            iPower: '',

            strVIN: '',

            fLat: 0,

            fLon: 0,

            strComment: '',

            strLicenseNo: '',

            strOtp: '',

            strActivateCode: '',

            bHas12DC: false

          });

        }

      });

  }

  signUp_User() {

    let model = this.signUpModel.getRawValue();

    this.markAllAsTouched(this.signUpModel);

    if (this.signUpModel.invalid) {

      return this.accountService.toastSwal('error', 'فیلدهای ضروری را تکمیل کنید');

    }

    if (model.strID && model.strID?.length !== 10) {

      return this.accountService.toastSwal('error', 'کد ملی باید 10 رقم باشد');

    }

    if (model.strID && !this.otherService.isValidNationalCode(model.strID)) {
      return this.accountService.toastSwal('error', 'کد ملی وارد شده صحیح نمی باشد');

    }

    if (this.forceAddress && (model.fLat == 0 || model.fLon == 0)) {

      return this.accountService.toastSwal('error', 'آدرس را از روی نقشه انتخاب کنید');

    }

    this.accountService.register(this.setEmptyString4NullValues(model)).subscribe((data) => {

      let res = JSON.parse(data.toString());

      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      this.bSendOtp = true;

      this.signUpModel.get('strMobile').disable();

      setTimeout(() => {

        this.startOtp_Timer();

      }, 10);

    });

  }

  startOtp_Timer() {

    const TOTAL_SECONDS = 119;

    const changeNumber_btn = document.getElementById('changeNumber-btn');

    const onChangeNumberClicked$ = fromEvent(changeNumber_btn, 'click');

    interval(1000).pipe(takeWhile((value) => value <= TOTAL_SECONDS), takeUntil(onChangeNumberClicked$)).subscribe({

      next: (value) => {

        const remaining = TOTAL_SECONDS - value;

        const minutes = Math.floor(remaining / 60).toString().padStart(2, '0');

        const seconds = (remaining % 60).toString().padStart(2, '0');

        this.otpTimer = `${minutes}:${seconds}`;

      },

      error: (err) => console.error(err),

      complete: () => (this.otpTimer = 0),

    });

  }

  check_Otp() {

    var model = {

      strMobile: this.signUpModel.get('strMobile')?.value,

      iOTP: this.signUpModel.get('strActivateCode')?.value,

    };

    this.accountService.otpCheck(model).subscribe((userData) => {

      let resParse = JSON.parse(userData.toString());

      if (resParse?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (resParse.iResult == 0) return this.accountService.toastSwal('error', resParse.strError);

      this.accountService.toastSwal('success', ` خوش آمدید`);

      var data = {

        Id: resParse[0].iPreregistration,

        session: resParse[0].strSession,

      };

      sessionStorage.setItem('info', JSON.stringify(data));

      if (this.isFromAnotherComponent) {

        if (this.redirectTo_id) {

          return this.router.navigate([`/${this.redirectTo}/${this.redirectTo_id}`]);

        }

        else this.router.navigate([`/${this.redirectTo}`]);

      }

      this.otherService.changeUserLogin_Status(true);

    });

  }

  checkRules(e) {

    this.rulesRead = e.target.checked;

  }

  sendAgain_Otp() {

    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,
    };

    this.accountService.otpAgain(model).subscribe((data) => {
      let res = JSON.parse(data.toString());

      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (res.bError)
        return this.accountService.toastSwal('error', res.strError);

      this.accountService.toastSwal('success', 'کد جدید ارسال شد');

      setTimeout(() => {
        this.startOtp_Timer();
      }, 10);
    });
  }

  backTo_ChangeNumber() {
    this.bSendOtp = false;
  }

  dismissModal() {

    this.router.navigate(['/home']);

    // let myModal = document.getElementById('exampleModal');

    // var modal = bootstrap.Modal.getInstance(myModal);

    // modal.hide();

    // this.bLoginMode = true;

    // this.bSendOtp = false;

    // this.isFromLoginForm = false;

    // this.signUpModel.get('strMobile').enable();

  }

  setEmptyString4NullValues(obj: any) {

    for (const key in obj) {

      if (obj[key] === null) obj[key] = '';

    }

    return obj;
  }

  getCity(id, resetCity: boolean = true) {

    this.accountService.GetCity(id).subscribe((response: any) => {

      let res = JSON.parse(response.toString());

      if (res?.ISSessionExpired === true) {
        this.otherService.logout();
        this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
        this.accountService.toastSwal(
          'error',
          'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
        );
      }

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      this.list_City = res;

      if (resetCity) {

        this.signUpModel.get('strCity')?.setValue('');

      }

    });

  }

  isFieldInvalid(fieldName: string): boolean {
    const control = this.signUpModel.get(fieldName);
    return !!control && control.invalid && (control.touched || control.dirty);
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }

  openAdd() {

    window.open(`/general`, '_blank', 'noopener noreferer');

  }

  show_Map() {

    let model = this.signUpModel.value;

    const { strCity, strAddress } = model;

    const cityObj = this.list_City.find(c => c.strCity === strCity);

    if (model.strAddress == '') {

      this._MapService.getCurrentLocation().then(coords => {

        this.mdl_Map.patchValue({

          strAddress: '',

          fLon: coords.longitude || 0,

          fLat: coords.latitude || 0,

          strSource: 'strAddress',

        });

        this.openMap = true;

      }).catch(error => {

        this.mdl_Map.patchValue({

          strAddress: '',

          fLon: model.fLon || 0,

          fLat: model.fLat || 0,

          strSource: 'strAddress',

        });

        this.openMap = true;

        console.error('Error getting location:', error);

      });


    }

    else {

      this.mdl_Map.patchValue({

        strAddress: this.baseAddress(),

        fLon: cityObj.fLon || 0,

        fLat: cityObj.fLat || 0,

        strSource: 'strAddress',

      });

      this.openMap = true;

    }

  }

  baseAddress(): string {

    const { strCity, strAddress } = this.signUpModel.value;

    const cityObj = this.list_City.find(c => c.strCity === strCity);

    if (!cityObj) return strAddress?.trim() ?? '';

    const cityName = cityObj.strCityName?.trim();

    if (!cityName) return strAddress?.trim() ?? '';

    const normalizedAddress = strAddress?.trim() ?? '';

    if (normalizedAddress.startsWith(cityName)) {

      return normalizedAddress;

    }

    return `${cityName}، ${normalizedAddress}`;

  }

  submitMap(event: any) {

    this.openMap = false;

    if (event.strText != '') {

      this.signUpModel.patchValue({

        strAddress: event.strText,

        fLon: event.longitude,

        fLat: event.latitude,

      });

    }

    else {

      this.signUpModel.patchValue({

        strAddress: '',

        fLon: 0,

        fLat: 0,

      });

    }

  }


}
